import { Http } from '../helpers'

export const JobService = {
  /**
   * ค้นหางานทั้งหมด
   * @param {*} params
   * @returns
   */
  async search(params) {
    return await Http.get('/jobs', { params: params })
  },
  /**
   * ค้นหางานที่กดส่งเข้ามาแล้วทั้งหมด เพื่อรอยืนยันกับลูกค้า
   * @param {*} params
   * @returns
   */
  async searchPendingConfirm(params) {
    return await Http.get('/jobs/pending-confirm', { params: params })
  },

  /**
   * ค้นหางานของตัวเองทีร้บผิดชอบ responsible_id = user_id
   * @param {*} params
   * @returns
   */
  async myjob(params) {
    return await Http.get('/jobs/my-job', { params: params })
  },
  async listProceed(params) {
    return await Http.get('/jobs/list-proceed', { params: params })
  },
  /**
   * รายการงานที่ยังไม่ได้ระบุเวลานัดหมาย
   * @param {*} params
   * @returns
   */
  async listNotime(params) {
    return await Http.get('/jobs/list-notime', { params: params })
  },
  /**
   * ค้นหาตามวันที่
   * @param {*} date
   * @returns
   */
  async bydate(params) {
    return await Http.get('/jobs/bydate', { params: params})
  },
  /**
   * ค้นหาตามปีและเดือน สำหรับปฏิทิน
   * @param {*} date
   * @returns
   */
  async byYearMonth(params) {
    return await Http.get('/jobs/byyearmonth', { params: params })
  },
  /**
   * ใช้กับ autocoplete ค้นหาได้
   * @returns
   */
  async autocomplete() {
    return await Http.get('/jobs/autocomplete')
  },
  async clearJobAuto() {
    return await Http.get('/jobs/check-job')
  },
  async view(id) {
    return await Http.get('/jobs/' + id)
  },
  async getJobStatus() {
    return await Http.get('/jobs/job-status')
  },
  /**
   * ยกเลิกงาน
   * @param {*} id
   * @param {*} params
   * @returns
   */
  async cancel(id, params = {}) {
    return await Http.put('/jobs/' + id + '/cancel', { params: params })
  },
  /**
   * ปิดงานและตรวจสอบสถานะใบแจ้งซ่อมด้วย
   * @param {*} id
   * @param {*} params
   * @returns
   */
  async close(id, params = {}) {
    return await Http.put('/jobs/' + id + '/close-job', { params: params })
  },
  /**
   * ตั้งเป็นยืนยันลูกค้าแล้ว
   * @param {*} id
   * @param {*} params
   * @returns
   */
  async markAsHasConfirmed(id, params = {}) {
    return await Http.put('/jobs/' + id + '/mark-as-confirmed', {
      params: params,
    })
  },
  // กดปุ่มเริ่มทำงาน
  async start(id, params = {}) {
    return await Http.put('/jobs/' + id + '/start-job', { params: params })
  },
  // กดปุ่มเริ่มส่งงานเมื่อเข้าซ่อมแล้ว เพื่อให้แอดมินโทรยืนยันลูกค้า
  async sendJob(id, params = {}) {
    return await Http.put('/jobs/' + id + '/send-job', { params: params })
  },
  // upload singnature
  async uploadSingnature(id, data) {
    return await Http.post('/jobs/' + id + '/save-signature', data)
  },
  // delete singnature
  async deleteSingnature(id, data) {
    return await Http.delete('/jobs/' + id + '/signature', data)
  },
  /**
   * เปลี่ยนสถานะงานตามที่ระบุ
   * @param {*} id
   * @param {*} params
   * @returns
   */
  async setJobStatus(id, params) {
    return await Http.put('/jobs/' + id + '/set-status', params)
  },
  /**
   * เพิ่มคิวงาน
   * @param {*} params
   * @returns
   */
  async create(params) {
    return await Http.post('/jobs', params)
  },
  /**
   * แก้ไขงานคิวงาน
   * @param {*} params
   * @returns
   */
  async update(id, params) {
    return await Http.put('/jobs/' + id, params)
  },
  async updateStarttime(id, params) {
    return await Http.put('/jobs/' + id + '/starttime', params)
  },
  async updateEndtime(id, params) {
    return await Http.put('/jobs/' + id + '/endtime', params)
  },

  // แก้ไขรายชื่อช่างอื่นๆ
  async updateTechnicianOther(id, params) {
    return await Http.put('/jobs/' + id + '/technician-other', params)
  },
  // มอบหมายงานกำหนดผู้รับผิดชอบ
  async updateResponsible(id, params) {
    return await Http.put('/jobs/' + id + '/responsible', params)
  },
  async assignTechnichian(id, params) {
    return await Http.put('/jobs/' + id + '/assign', params)
  },
  async postponeJob(id, params) {
    return await Http.put('/jobs/' + id + '/postpone-job', params)
  },
  async reConfirmAssign(id, params) {
    return await Http.put('/jobs/' + id + '/reassign', params)
  },
  async delete(id) {
    return await Http.delete('/jobs/' + id)
  },
  // อัพโหลดรูปหลายรูป
  async upload(params) {
    return await Http.post('/jobs/upload', params, {
      'Content-Type': 'multipart/form-data',
    })
  },
  async deleteFile(id) {
    return await Http.delete('/jobs/file/' + id)
  },
  async viewFile(id) {
    return await Http.get('/jobs/file/' + id)
  },
}
